@use '@lib/assets/styles/main.scss' as *;

.lockedWrapper {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
}
